import { api } from './api';

// Use Node.js backend (PaddleOCR)
// Optional sourceCategory lets us tag recipes (e.g., scope2-elektriciteti) when uploading.
export const runOcr = async (file, buildingId = null, sourceCategory = null) => {
  const fd = new FormData();
  fd.append('file', file);
  if (buildingId) fd.append('buildingId', buildingId);
  if (sourceCategory) fd.append('source_category', sourceCategory);

  const { data } = await api.post('/api/ocr', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  return {
    ...data,
    usingPythonOCR: false,
    fallbackReason: 'Python OCR disabled (frontend)'
  };
};

export const runOcrText = async (file) => {
  const result = await runOcr(file);
  return result.text || '';
};
